import { VendorBuyOpportunityDetails } from '../../../components/Vendor';

export function BuyOpportunityDetails() {
  return <VendorBuyOpportunityDetails />;
}
